import React from 'react';
import videoExtensions from 'video-extensions';

export const isVideo = (url: $TSFixMe) => {
  if (url && url !== '/images/logo.png') {
    try {
      const urlOb = new URL(url);
      const urlParts = urlOb.pathname.split('.');
      return videoExtensions.includes(urlParts[urlParts.length - 1]);
    } catch (e) {
      process.env.NODE_ENV === 'development' && console.error(e);
    }
  }
  return false;
};

export const renderVideo = (video: $TSFixMe, isFullScreen: $TSFixMe) => {
  return () => {
    return (
      <video
        src={video.url}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; src: any; alt: string; w... Remove this comment to see the full error message
        alt="Project Video"
        width="100%"
        // autoPlay
        controls
        muted
        style={{maxHeight: isFullScreen ? '80vh' : '36vh'}}>
        Sorry, your browser doesn't support embedded videos
      </video>
    );
  };
};

export const openFullScreenVideo = (id: $TSFixMe, url: $TSFixMe) => {
  if ((window as $TSFixMe).ReactNativeWebView) {
    (window as $TSFixMe).ReactNativeWebView.postMessage(JSON.stringify({url}));
  } else {
    const elem = document.getElementById(id);
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (elem.requestFullscreen) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      elem.requestFullscreen();
    } else if ((elem as $TSFixMe).mozRequestFullScreen) {
      (elem as $TSFixMe).mozRequestFullScreen();
    } else if ((elem as $TSFixMe).webkitRequestFullscreen) {
      (elem as $TSFixMe).webkitRequestFullscreen();
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    } else if (elem.msRequestFullscreen) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      elem.msRequestFullscreen();
    } else {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      window.open(url, '_blank').focus();
    }
  }
};
